import { render, staticRenderFns } from "./EachCocktail.vue?vue&type=template&id=48ffec62&scoped=true&"
import script from "./EachCocktail.vue?vue&type=script&lang=js&"
export * from "./EachCocktail.vue?vue&type=script&lang=js&"
import style0 from "./EachCocktail.vue?vue&type=style&index=0&id=48ffec62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffec62",
  null
  
)

export default component.exports